module.exports = __webpack_public_path__ + "img/cuco_looking_up_mobile.adafea0a.png";